export const CarnetTypes: any[] = [
    {
        "label": "ATA_CARNET.CARNET_REGULAR",
        "value": "regular",
        "description": "ATA_CARNET.CARNET_REGULAR_DESC"
    },
    {
        "label": "ATA_CARNET.CARNET_OPEN",
        "value": "open",
        "description": "ATA_CARNET.CARNET_OPEN_DESC",
        "information": [
            { "title": "ATA_CARNET.CARNET_OPEN_INFO_1" },
            { "title": "ATA_CARNET.CARNET_OPEN_INFO_2" },
            { "title": "ATA_CARNET.CARNET_OPEN_INFO_3" },
            { "title": "ATA_CARNET.CARNET_OPEN_INFO_4" },
            { "title": "ATA_CARNET.CARNET_OPEN_INFO_5" },
            { "title": "ATA_CARNET.CARNET_OPEN_INFO_6" }
        ]
    }
];

export const BranchLocation: any = {
    title: 'LOCATION.TITLE',
    message: 'LOCATION.DESCRIPTION',
    sections: [
        {
            title: 'LOCATION.ADDRESS_TITLE',
            items: ['LOCATION.ADDRESS'],
        },
        {
            title: 'LOCATION.OFFICE_HOURS_TITLE',
            items: [
                'LOCATION.OFFICE_HOURS_MON_THU',
                'LOCATION.OFFICE_HOURS_FRI',
                'LOCATION.OFFICE_HOURS_SAT_SUN',
            ],
        }
    ],
};